export const FLAGSHIP_EVENT_ON_SORT_SELECTION = {
	recommendation: "CLICK_ON_SDP_LISTING_SORT_RECO",
	price_asc: "CLICK_ON_SDP_LISTING_SORT_PRICE_ASC",
	price_desc: "CLICK_ON_SDP_LISTING_SORT_PRICE_DESC",
	rating_desc: "CLICK_ON_SDP_LISTING_SORT_RATING",
	stars_desc: "CLICK_ON_SDP_LISTING_SORT_STARS",
	discount_desc: "CLICK_ON_SDP_LISTING_SORT_DISCOUNT",
};
